<template>
    <div class="agendamento__badge__container success">
        <b-badge class="w-100" :class="status" :id="'tooltip-target-badge-'+randomId">
          <b-tooltip :target="'tooltip-target-badge-'+randomId" triggers="hover">
            <p v-html="tooltipText"></p>
          </b-tooltip>
            <div class="agendamento__badge__inner__container" style="font-size: 11px !important;">
                <i class="agendamento__badge__icon" :class="icon"></i>
                <p class="agendamento__badge__text">{{ text }}</p>
            </div>
        </b-badge>
    </div>
</template>
<script>

export default {
  name: 'NxBadge',
  data () {
    return {
      example: 'JAN 27, 15:50'
    }
  },
  computed: {
    randomId () {
      return Math.random().toString(36)
    }
  },
  props: {
    icon: {
      type: String,
      required: false,
      default: ''
    },
    text: {
      type: String,
      required: false,
      default: ''
    },
    tooltipText: {
      type: String,
      required: false,
      default: ''
    },
    status: {
      type: String,
      required: true,
      validator: function (value) {
        return ['green', 'yellow', 'red', 'default'].includes(value)
      }
    }
  }
}
</script>
<style lang="scss">
.agendamento__badge{

    &__inner__container{
        display: flex;
        gap: .5rem;
        padding: 2px;
        // padding: .1rem .3rem;

        p{
            margin: 0;
        }
    }

    &__text{
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    &__container{
        font-weight: bold;
        padding: 0;

        .default{
          background: transparent;
          color: #7d7d7d;
        }
        .green{
            background: #DCF8EC;
            color: #216E4E;
        }
        .yellow{
            background: #E2B203;
            color: #FFF;
        }
        .red{
            background: #FFD2CC;
            color: #AE2A19;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/nexum/components/badge/NxBadge.vue